<script>
    import { store } from '../Store.svelte';
</script>

{#if $store.requestedServices.isSky}
    <footer class="footer-sky">
        <div class="footer-logo-container">
            <img src="/assets/img/logos/sky-logo.svg" alt="Sky" />
            <p>
                “Sky” y las marcas relacionadas, nombres y logotipos, son
                propiedad de “Sky International AG” y otras empresas del grupo.
            </p>
        </div>
        <ul class="footer-links">
            <li>
                <a href="https://www.sky.com.mx/terminos"
                    >Avisos, términos y condiciones legales</a
                >
            </li>
        </ul>
        <div class="separator"></div>
        <p class="text-fs-12 fw-regular">
            © Corporación Novavisión S. de R.L. de C.V. 2022. Prohibida su
            reproducción total o parcial. Av. Insurgentes Sur 694, Col. Del
            Valle, Ciudad de México.
        </p>
    </footer>
{:else}
    <footer>
        <div class="pure-g align-items-center">
            <div class="pure-u-1 pure-u-md-15-24 main-col">
                <img
                    src="/assets/img/logos/izzi-logo-letter-white.svg"
                    alt="izzi"
                    class="footer-logo"
                />
            </div>
            <div class="pure-u-1 pure-u-md-9-24 md-text-right">
                <p>© 2025, izzi.mx. Todos los derechos reservados.</p>
            </div>
        </div>
    </footer>
{/if}
